<template>
  <v-app>
    <v-app-bar app :color="scrolled ? 'white' : 'white'" elevate-on-scroll flat >
      <v-container class="d-flex align-center justify-space-between">
        <!-- LOGO -->
        <div class="d-flex align-center">
          <v-img
            alt="Logo"
            :src="require('@/assets/FULL COLOR.png')"
            contain
            height="80"
            width="80"
            class="mr-3"
          />
          <span
            class="text-h6 font-weight-bold"
            style="
              color: red;
              font-family: 'Roboto Condensed', sans-serif !important;
            "
            >LAVANDERÍA
            <strong :style="{ color: scrolled ? 'var(--dark-blue)' : 'var(--dark-blue)' }">LIZ</strong></span
          >
        </div>

        <!-- MENÚ DESKTOP -->
        <div class="d-none d-md-flex" >
          <v-btn text href="#nosotros" class="mx-2" :style="{ color: scrolled ? 'red' : 'var(--dark-blue)' }">Nosotros</v-btn>
          <v-btn text href="#servicios" class="mx-2" :style="{ color: scrolled ? 'red' : 'var(--dark-blue)' }">Servicios</v-btn>
          <v-btn text href="#contacto" class="mx-2" :style="{ color: scrolled ? 'red' : 'var(--dark-blue)' }">Contacto</v-btn>
        </div>
        <!-- MENÚ MÓVIL -->
        <v-btn icon class="d-md-none" @click="drawer = !drawer">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </v-container>
      <!-- DRAWER PARA MÓVIL -->
      <v-navigation-drawer
        v-model="drawer"
        temporary
        app
        disable-resize-watcher
      >
        <v-list dense>
          <v-list-item link @click="goToSection('#nosotros')">
            <v-list-item-title>Nosotros</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="goToSection('#servicios')">
            <v-list-item-title>Servicios</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="goToSection('#contacto')">
            <v-list-item-title>Contacto</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </v-app-bar>
    <v-main>
      <HomePageComponent />
    </v-main>
    <v-footer class="app-footer" elevation="4">
      <v-container>
        <v-row>
          <v-col cols="12" md="3">
            <span><i class="mdi mdi-web"></i> www.lavanderializ.com.pe</span>
          </v-col>
          <v-col cols="12" md="3">
            <span><i class="mdi mdi-phone"></i> 981321905</span>
          </v-col>
          <v-col cols="12" md="3">
            <span
              ><i class="mdi mdi-map-marker"></i> Jr. Pedro Ruiz Nro 403, Pueblo
              Libre - Lima.</span
            >
          </v-col>
          <v-col cols="12" md="3">
            <span
              ><i class="mdi mdi-facebook"></i>Lavandería Liz</span
            >
          </v-col>
        </v-row>
        <hr />
        <v-row>
          <v-col class="text-center">
            <span>© 2025 Lavandería Liz</span>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
//import HelloWorld from './components/HelloWorld';
import HomePageComponent from "./components/HomePageComponent.vue";

export default {
  name: "App",

  components: {
    //HelloWorld,
    HomePageComponent,
  },

  data() {
    return {
      drawer: false,
      scrolled: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 50; // Cambia el valor según cuándo quieras que cambie
    },
    goToSection(selector) {
      this.drawer = false;
      const el = document.querySelector(selector);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Baloo+2:wght@400..800&family=Barlow+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Quicksand:wght@300..700&family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&display=swap");
:root {
  --dark-blue: #002d72; /* para subtítulos y énfasis */
  --primary-blue: #0054a6; /* para texto general */
  --light-blue-bg: rgba(0, 45, 114, 0.06);
  --soft-gray-bg: #f2f2f2;
  --soft-red-bg: rgba(206, 46, 58, 0.06);
  --white: #ffffff;
}
html {
  scroll-behavior: smooth;
}
body {
  font-family: "Roboto", sans-serif;
  color: var(--primary-blue);
  background-color: var(--white);
  margin: 0;
  padding: 0;
  line-height: 1.6;
}
.v-app-bar {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}
h1,
h2,
h3,
h4 {
  color: var(--dark-blue);
  margin-bottom: 0.5rem;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

a {
  color: var(--primary-blue);
  text-decoration: none;
}
a:hover {
  color: var(--accent-red);
}
li {
  list-style: none;
  display: inline-flex;
}
.app-footer {
  background-color: #102542 !important;
  color: #ffffff !important;
  padding: 24px 0 !important;
  font-size: 0.95rem !important;
}

.app-footer .mdi {
  margin-right: 8px !important;
  font-size: 1.2rem !important;
  vertical-align: middle !important;
}

.app-footer hr {
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin: 16px 0;
}

.app-footer .text-center {
  color: rgba(255, 255, 255, 0.7);
}
</style>
